'use strict';

const $ = require('jquery');
const cookies = require('js-cookie');

const COOKIES = {
    FIRST_NAME: 'bo_first_name',
};

const SELECTORS = {
    CONTAINER: '.global-nav-greeting',
    NAME: '.global-nav-greeting__name',
};

const CLASSES = {
    HIDDEN: 'global-nav-greeting--hidden',
};

function init() {
    const firstNameCookie = cookies.get(COOKIES.FIRST_NAME);

    if (!firstNameCookie) {
        $(SELECTORS.CONTAINER).addClass(CLASSES.HIDDEN);
        return;
    }

    $(SELECTORS.NAME).text(firstNameCookie);
}

module.exports = {
    init
};



// WEBPACK FOOTER //
// ./modules/welcomeMessage.js